import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Portfolio(){
  return(
    <Container id="portfolio">
      <h2>Proyectos</h2>

      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
        <div className="project">
          <header>
          <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          <div className="project-links">
            
            <a href="https://github.com/nicolasyunes/foods-drinks" target="_blank" rel="noreferrer">
              <img src={githubIcon} alt="GitHub" />
            </a>
             <a href="https://foods-drinks.vercel.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="GitHub" />
              </a>
          </div>
          </header>
          <div className="body">
            <h3>Foods and Drinks</h3>
            <p>Una aplicacion para crear menus de comidas y bebidas con usuario logeado.
            </p>
          </div>
          <footer>
            <ul className="tech-list">
              <li>Node</li>
              <li>Express</li>
              <li>MongoDb</li>
              <li>React</li>
              <li>Styled-components</li>
            </ul>
          </footer>
        </div>
      </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="#" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://github-search-blond.vercel.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Github Searcher</h3>
              <p>Una version de Github search para ver su perfil y de otros usuarios.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Styled Components</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

       

       

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Site" />
              </a>
              <a href="https://github.com/nicolasyunes/To-do-nodejs-" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>To-do</h3>
              <p>To-do app en NodeJs.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>NodeJS</li>
              
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Site" />
              </a>
              <a href="https://github.com/nicolasyunes/AppClima-NodeJS" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>App Clima</h3>
              <p>Aplicacion hecha con Node JS para consultar la temperatura en cualquier parte del mundo utilizando Api openweathermap . 
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>NodeJS</li>
                <li>Axios</li>
                
                <li>javascript</li>
              
              </ul>
            </footer>
          </div>
        </ScrollAnimation>



      </div>
    </Container>
  );
}